import { render, staticRenderFns } from "./MStorePopup.vue?vue&type=template&id=5c78b572&"
import script from "./MStorePopup.vue?vue&type=script&lang=ts&"
export * from "./MStorePopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports